import {PlanDiscountMode} from '../../graphql/queries-schema';

export const SUBSCRIPTION_OTP_FROM_KEY = 'one-time-purchase';

export interface IPlanDiscount {
  mode: PlanDiscountMode;
  value: number;
}

export function applyPlanDiscount(basePrice: number, discount: IPlanDiscount): number {
  if (discount.mode === 'PERCENT') {
    return basePrice * (1 - discount.value / 100);
  }
  return basePrice - discount.value;
}
